import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=d32e23a4&"
import script from "./Help.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Help.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports